import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=f73c4a7e&scoped=true"
import script from "./startPage.vue?vue&type=script&lang=js"
export * from "./startPage.vue?vue&type=script&lang=js"
import style0 from "./startPage.vue?vue&type=style&index=0&id=f73c4a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73c4a7e",
  null
  
)

export default component.exports